/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Web3 from "web3";

// Actions
import { toggleModal, resetUser, connectWallet } from "../../redux/actions";

// Components
import StepperComponent from "../reusables/Steppers";
import ProvideForm from "./MultisendForms/FormOne";
import ApproveForm from "./MultisendForms/FormTwo";
import SuccessPage from "./MultisendForms/SuccessPage";
import SelectNetwork from "../auth/SelectNetwork";
import AuthHeader from "../reusables/Navs/AuthHeader";

// Utils
import { formatAddress } from "../../methods/helper";
import { persistor } from "./../../redux/index";
import modalConstants from "../reusables/modal/modalConstants";

const MultisendPageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  width: 100%;
  height: 100%;

  .blob-1 {
    position: absolute;
    bottom: 0px;
    left: -150px;
    opacity: 0.7;
    z-index: 1;
    width: 1323px;
    height: 100%;
  }
`;

const steps = [
  { label: "Provide" },
  { label: "Approve" },
  { label: "Sending" },
];

const Multisend = ({ currentTheme, themeToggler }) => {
  const modalPage = useSelector((state) => state.GeneralReducer.modalPage);
  const user = useSelector((state) => state.persistedStore);

  const [activeStep, setActiveStep] = useState(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [sendNativeToken, setSendNativeToken] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const connectToNetwork = async (network) => {
    dispatch(connectWallet(network));
  };

  const handleNextStep = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep(activeStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleDisconnect = () => {
    persistor.purge().then(() => {
      dispatch(resetUser());
      dispatch(toggleModal(0));
      setWalletBalance(0);
      navigate("/");
    });
  };

  useEffect(() => {
    if (user.address) {
      const web3 = new Web3(window.ethereum); // Replace with your Infura Project ID
      const fetchBalance = async () => {
        let balanceWei = await web3.eth.getBalance(user.address);
        // Convert balance from Wei to Ether
        const formattedBalance = web3.utils.fromWei(balanceWei, "ether");
        setWalletBalance(formattedBalance);
      };
      fetchBalance();
    }
  }, [user]);

  useEffect(() => {
    // handle switching of account
    const handleAccountsChanged = async (accounts) => {
      const persistStore = JSON.parse(
        localStorage.getItem("persist:persistedStore")
      );

      if (accounts.length > 0) {
        const changedAddress = {
          ...persistStore,
          // eslint-disable-next-line no-useless-escape
          address: `\"${accounts[0]}\"`,
        };
        const stringifiedData = JSON.stringify(changedAddress);
        localStorage.setItem("persist:persistedStore", stringifiedData);
        window.location.reload();
      } else {
        /* empty */
      }
    };

    if (window.ethereum) {
      window.ethereum.on("accountsChanged", handleAccountsChanged);
    }

    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener(
          "accountsChanged",
          handleAccountsChanged
        );
      }
    };
  }, [dispatch]);

  return (
    <div style={{ padding: "20px" }}>
      <AuthHeader
        address={formatAddress(user.address)}
        currentTheme={currentTheme}
        handleDisconnect={handleDisconnect}
        network={user?.network?.nativeCurrency?.symbol}
        themeToggler={themeToggler}
      />
      <MultisendPageContentWrapper>
        <img
          src="/assets/img/SVG/blob-2.svg"
          className="blob-1"
          alt="blob-1"
          style={{ zIndex: 1 }}
        />
        <StepperComponent activeStep={activeStep} steps={steps} />
        {activeStep === 0 && (
          <ProvideForm
            handleNextStep={handleNextStep}
            walletBalance={walletBalance}
            // connectedNetwork={networkName}
            walletAddress={user?.address}
            chainId={user?.network?.chainId}
            setSendNativeToken={setSendNativeToken}
            sendNativeToken={sendNativeToken}
            nativeTokenSymbol={user?.network?.nativeCurrency?.symbol}
            currentTheme={currentTheme}
          />
        )}
        {activeStep === 1 && (
          <ApproveForm
            handleNextStep={handleNextStep}
            handlePrevStep={handlePrevStep}
            walletBalance={walletBalance}
            chainId={user?.network?.chainId}
            sendNativeToken={sendNativeToken}
            setSendNativeToken={setSendNativeToken}
            network={user?.network}
          />
        )}
        {activeStep === 2 && <SuccessPage setActiveStep={setActiveStep} />}
      </MultisendPageContentWrapper>
      {modalPage === modalConstants.SelectNetwork ? (
        <SelectNetwork
          connectToNetwork={connectToNetwork}
          currentTheme={currentTheme}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Multisend;
